import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import YellowBannerView from "../views/YellowBannerView.vue";
import PromoView from "../views/PromoView.vue";
import GameDescriptionView from "../views/GameDescriptionView.vue";
import EngagementPromoView from "../views/EngagementPromoView.vue";
import CrossPromotionView from "../views/CrossPromotionView.vue";
import PreviewMode from "../views/PreviewMode.vue";
import ImagesView from "../views/ImagesView.vue";
import ClearCacheView from "../views/ClearCacheView.vue";
import store from "@/store";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/yellowBanner",
    name: "yellowBanner",
    component: YellowBannerView,
    meta: { requiresAuth: true },
  },
  {
    path: "/promos",
    name: "promos",
    component: PromoView,
    meta: { requiresAuth: true },
  },
  {
    path: "/gamesDescription",
    name: "gamesDescription",
    component: GameDescriptionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/engagementPromo",
    name: "engagementPromo",
    component: EngagementPromoView,
    meta: { requiresAuth: true },
  },
  {
    path: "/crossPromotion",
    name: "crossPromotion",
    component: CrossPromotionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/previewMode",
    name: "previewMode",
    component: PreviewMode,
    meta: { requiresAuth: true },
  },
  {
    path: "/images",
    name: "images",
    component: ImagesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/clearCache",
    name: "clearCache",
    component: ClearCacheView,
    meta: { requiresAuth: true, adminAuth: true },
  },
  { path: "/:pathMatch(.*)*", name: "notfound", component: HomeView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const user = store.getters["auth/getUser"];
function isAuthenticated(to, user) {
  if (to.meta.adminAuth) {
    return user && user.idTokenClaims.roles.includes("Admin");
  } else {
    return !!user;
  }
}
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated(to, user)) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
